// use-reset-tree-select

import { GenericType } from "@/types";
import { create } from "zustand";

interface ResetTreeSelectState {
  isReset: boolean;
  dragParentId: string | undefined;
  setIsReset: (prop: GenericType) => void;
  setDragParentId: (prop: GenericType) => void;
}

export const useResetTreeSelect = create<ResetTreeSelectState>((set) => ({
  isReset: false,
  dragParentId: undefined,
  setIsReset: (value) => set(() => ({ isReset: value })),
  setDragParentId: (value) => set(() => ({ dragParentId: value })),
}));
